import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.app.bitcoin,
    (bitcoin) => {
        return {
            bitcoin
        }
    }
)